import { createSlice } from '@reduxjs/toolkit';

export const userController = createSlice({
    name:'userController',
    initialState:{user:null},
    reducers: {
        setUserData(state,action){
            state.user = action.payload
        },
        clearData(state){
            state.user = null
        },
    }
}) 


export const userActions = userController.actions